import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
/**
 *
 * Button
 *
 */

/* eslint react/button-has-type: off */

import React from 'react';
import classnames from 'classnames';
import Icon from '../Icon';

var Button = function Button(_ref) {
  var ariaLabel = _ref.ariaLabel,
      disabled = _ref.disabled,
      extraClasses = _ref.extraClasses,
      onClick = _ref.onClick,
      theme = _ref.theme,
      type = _ref.type,
      variation = _ref.variation,
      children = _ref.children,
      extraProps = _objectWithoutProperties(_ref, ["ariaLabel", "disabled", "extraClasses", "onClick", "theme", "type", "variation", "children"]);

  var iconOnly = children.type && children.type === Icon;
  return React.createElement("button", _extends({
    "aria-label": ariaLabel,
    className: classnames(!iconOnly && 'button', theme, variation, extraClasses),
    onClick: onClick,
    type: type,
    disabled: disabled ? 'disabled' : ''
  }, extraProps), children);
};
/* istanbul ignore next */


Button.defaultProps = {
  disabled: false,
  extraClasses: '',
  onClick: function onClick() {},
  theme: 'primary',
  type: 'button',
  variation: '',
  children: 'Submit'
};
Button.displayName = 'Button';
export default Button;